import { render, staticRenderFns } from "./fmSelectDadata.vue?vue&type=template&id=bc2cb38a&scoped=true"
import script from "./fmSelectDadata.vue?vue&type=script&lang=js"
export * from "./fmSelectDadata.vue?vue&type=script&lang=js"
import style0 from "./fmSelectDadata.vue?vue&type=style&index=0&id=bc2cb38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2cb38a",
  null
  
)

export default component.exports